import React, { useEffect, useState } from 'react';

import { getInspirationsPageNumber, getLayoutInspirations } from '../../store/Selectors';
import DslStore from '../../store/DslStore';
import { useStoreState } from 'pullstate';

import { PaginationSwitch } from '../../components/Inspirations/InspirationsNavigation/InspirationsNavigationWLF';
import { Contest, Inspiration, User } from '../../global';
import { useNavigate } from 'react-router-dom';
import InspirationsNavigationWLF from '../../components/Inspirations/InspirationsNavigation/InspirationsNavigationWLF';
import { useAuth } from '../../context/AuthContext';
import { briefUrlForContest } from '../../helpers/navigationUtils';
import { useBanner } from '../../context/BannerContext';
import NewInspirationCard from '../../components/Inspirations/InspirationCard/NewInspirationCard';
import AddInspirationCard from '../../components/Inspirations/InspirationCard/AddInspirationCard';
import InspirationEditor from '../../components/Inspirations/InspirationEditor';
interface ContestWLFProps {
  contest: Contest;
  loginCallback: () => void;
}

const InspirationsWLF: React.FC<ContestWLFProps> = ({ contest, loginCallback }) => {
  const [disableEdit, setDisableEdit] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editedInspiration, setEditedInspiration] = useState<Inspiration | null>(null);
  const [allInspirations, setAllInspirations] = useState<Inspiration[]>([]);
  const [visibleInspirations, setVisibleInspirations] = useState<Inspiration[]>([]);
  const { loggedUser } = useAuth();
  const pageNumber = useStoreState(DslStore, getInspirationsPageNumber);
  const redirect = useNavigate();
  const navigate = useNavigate();
  const { createAndAddBannerMessage } = useBanner();
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    if (shouldRedirect) {
      navigate(briefUrlForContest(contest));
    }
  }, [shouldRedirect, navigate]);

  useEffect(() => {
    if (contest) {
      if (contest.hideInspirationTab || contest.needsAccessCode || contest.needsNDA) {
        createAndAddBannerMessage('Access denied', 'error', 'access-denied' + contest.id);
        setShouldRedirect(true);
      } else {
        setAllInspirations(contest.inspirations);
      }
      if (contest.isClosed || new Date(contest.endUploadDate) < new Date()) {
        setDisableEdit(true);
      } else {
        setDisableEdit(false);
      }
    }
  }, [contest]);

  const arraysfill = () => {
    // let chunkSize = 19;
    // let startchunk = (pageNumber - 1) * chunkSize;
    // let tempArray: Inspiration[] = [];
    // let removePrivate: Inspiration[] = [];
    // if (allInspirations) {
    //   allInspirations.map((item) => {
    //     if (item.isPrivate) {
    //       if (item.user.id === user?.id || user?.userType === 'G' || user?.id === contest.userId) {
    //         removePrivate.push(item);
    //       }
    //     } else {
    //       removePrivate.push(item);
    //     }
    //   });
    //   let chunk: Inspiration[] = removePrivate !== undefined ? removePrivate.slice(startchunk, startchunk + chunkSize) : [];
    //   for (let i = 0; i < removePrivate!.length; i += chunkSize) {
    //     chunk = removePrivate!.slice(startchunk, startchunk + chunkSize);
    //     // console.log('chunk');
    //     // console.log(chunk);
    //   }
    //   for (let i = 0; i < chunkSize; i++) {
    //     // console.log(chunk[i]);
    //     // console.log(chunk[i] === undefined);
    //     if (chunk[i] !== undefined) {
    //       tempArray.push(chunk[i]);
    //     } else {
    //       break;
    //     }
    //   }
    //   // console.log("array1:  ");
    //   // console.log(tempArray);
    //   tempArray.unshift(firstInspiration);
    //   setVisibleInspirations(tempArray);
    // }
    setVisibleInspirations(allInspirations);
  };

  const reloadInspiration = () => {
    // setInspiration(contest.inspirations);
    // setInspirationCopy(contest.inspirations);
    // axiosHelper.getInspiration(props.contest?.id)?.then((response) => {
    //   setInspiration(response.inspirations);
    //   setInspirationCopy(response.inspirations);
    // });
  };

  // const fetchContestByName = (contestName: string) => {
  //   console.log('BY NAME');
  //   if (contestName) {
  //     axiosHelper
  //       .retrieveContestByName(contestName)
  //       .then((response) => {
  //         // console.log(response);
  //         setCurrentContest(response.data);
  //         setContestTags(response.data.tags);
  //       })
  //       .catch((error) => {
  //         throw error;
  //       });
  //   }
  // };

  // useEffect(() => {
  //   console.log(nameForURL);
  //   nameForURL && nameForURL !== contest?.nameForURL && fetchContestByName(nameForURL);
  // }, [nameForURL]);

  useEffect(() => {
    // arraysfill();
  }, [pageNumber]);

  useEffect(() => {
    arraysfill();
  }, [allInspirations]);

  const createNewInspiration = () => {
    setEditedInspiration(null);
    setEditMode(true);
  };
  const editInspiration = (inspiration: Inspiration) => {
    setEditedInspiration(inspiration);
    setEditMode(true);
  };

  const didVoteCallback = (votedInspiration: Inspiration) => {
    if (votedInspiration) {
      setAllInspirations((prevInspirations) => prevInspirations.map((inspiration) => (inspiration.id === votedInspiration.id ? votedInspiration : inspiration)));
    }
  };

  const saveCallback = (newInspiration: Inspiration | null) => {
    if (newInspiration) {
      setAllInspirations((prevInspirations) => {
        if (editedInspiration) {
          // Editing an existing inspiration
          return prevInspirations.map((inspiration) => (inspiration.id === newInspiration.id ? newInspiration : inspiration));
        } else {
          // Creating a new inspiration
          return [newInspiration, ...prevInspirations];
        }
      });
    }
    setEditMode(false);
  };
  return (
    <div className="bg-light-gray">
      {/* <main className={`container pt-5 mb-5 px-sm-0 `}> */}
        {editMode ? (
          <InspirationEditor inspiration={editedInspiration} contest={contest} saveCallback={saveCallback} closeCallback={() => setEditMode(false)} />
        ) : (
          <>
            <div className="row">
              <div className="col-12  ">{/* <InspirationsNavigationWLF onChangeLayout={setLayoutInspirations} /> */}</div>
            </div>
            <div className="row d-flex flex-row ">
              <AddInspirationCard disabled={disableEdit} clickCallback={createNewInspiration} />

              {/* {layoutInspirations === 1 && */}
              {visibleInspirations?.map((aInspiration: Inspiration, index: number) => (
                <NewInspirationCard
                  changeCallback={didVoteCallback}
                  inspiration={aInspiration}
                  loggedUser={loggedUser}
                  key={index}
                  shownInUserProfile={false}
                  editCallback={editInspiration}
                />
              ))}
            </div>
            <div className="row mt-3 px-4"></div>
            <div className="row ">
              <div className="col-12 px-4 d-flex justify-content-sm-start justify-content-md-end ">
                {/* {visibleInspirations.length > 0 ? <PaginationSwitch onChangePage={setInspirationPageNumber} /> : ''} */}
              </div>
            </div>
          </>
        )}
      {/* </main> */}
    </div>
  );
};

export default InspirationsWLF;
